import React from 'react';

const SysconfigContext = React.createContext({});

export default SysconfigContext;
